export const usesMembershipV2Credits = booking =>
  booking?.usesMembershipV2Credits === true ||
  booking?.membershipV2CreditSummary?.provider === 'membership_v2' ||
  booking?.familyMembers?.some(member => member?.usesMembershipV2Credits === true) === true;

export const classCancellationError = ({companyData, booking, now = new Date()}) => {
  if (companyData?.CTCM === true) {
    return 'Please contact your coach to cancel this Class.';
  }

  const rawHours = companyData?.cancelClassHrs;
  if (rawHours === null || rawHours === undefined || rawHours === '') {
    return 'Please contact your coach to cancel this Class.';
  }

  const hours = Number(rawHours);
  const classStart = booking?.start ? new Date(booking.start) : null;
  if (!classStart || Number.isNaN(classStart.getTime()) || Number.isNaN(hours)) {
    return 'Unable to determine the class cancellation deadline. Please contact your coach.';
  }

  const cutoff = new Date(classStart.getTime() - hours * 60 * 60 * 1000);
  return now >= cutoff
    ? `Cancellation is not allowed within ${rawHours} hours of the class start.`
    : null;
};

export const clientCanCancelCamp = booking =>
  booking?.isCamp !== true || usesMembershipV2Credits(booking);

export const clientCanCancelCampParticipant = (booking, participant) =>
  booking?.isCamp !== true || participant?.usesMembershipV2Credits === true;
